<template>
  <div :class="$style.wrapper">
    <app-prev-button v-if="auth_info" @click="$router.go(-1)" :no-mobile="true"/>
    <h1 :class="$style.h1">よくある質問</h1>
    <section
      v-for="(qaSection, qaSection_i) in qaSections"
      :key="qaSection_i"
      :class="$style.section"
    >
      <h2 :class="$style.h2">{{qaSection.h}}</h2>
      <base-accordion
        v-for="(qa, qa_i) in qaSection.qas"
        :key="qa_i"
        type="qa"
        :class="$style.accordion"
        :title="qa.q"
      >
        <p :class="$style.p" v-html="qa.a"></p>
      </base-accordion>
    </section>
  </div>
</template>
<script>
import BaseAccordion from '@/components/base/BaseAccordion/BaseAccordion'
import AppPrevButton from '@/components/app/AppPrevButton/AppPrevButton'
export default {
  components: { BaseAccordion, AppPrevButton },
  data() {
    return {
      qaSections: [{
        qas: [{
          q: "ju-IDとはなんですか",
          a: "くみあいアプリで新規登録を行うと自動で発行されるIDです。j.unionのシステムをご利用されるユーザー様毎に1つ発行されます。<br>「メニュー」から「プロフィール」を選択し『プロフィール画面』を表示すると確認できます。<br>j.unionの各種システムをご利用で（別途ご契約が必要です）、「くみあいアプリ共通ログイン」をご利用になる場合、システム同士がユーザーを認識するためのIDとなります。<br>くみあいアプリ内では、このIDを利用してチームへの招待が可能です。<br>※招待方法は「チームにメンバーを招待したいです」を参照ください。"
        }, {
          q: "新規登録の際に必要なものはなんですか",
          a: "新規登録を行うためには、「携帯電話番号」か「メールアドレス」が必要です。<br>「携帯電話番号」または「メールアドレス」を入力すると、「確認コード」を送付しますので、一定時間内に指定の画面に確認コードの入力を行ってください。<br>確認コードが合致することで利用者の個人認証を行います。<br>登録後、ログインする際には認証情報として利用した「携帯電話番号」または「メールアドレス」と「パスワード」の入力が必要です。<br>「携帯電話番号」または「メールアドレス」は個人を認証する情報のため、グループで利用している電話番号やメールアドレスを登録することはできません。"
        },{
          q: "パスワードを忘れました",
          a: "ログイン画面の下部にある「ID・パスワードを忘れた方はこちら」をクリックしてください。<br>『パスワード再発行画面」が表示されますので、認証情報として入力している「電話番号」または「メールアドレス」と新規登録時に設定した「生年月日」を入力してください。<br>パスワード再発行メールが送信されますので、メール本文にしたがって再発行手続きを進めてください。"
        },{
          q: "確認コードが届きません",
          a: "確認コードが届かない場合は以下の項目を確認してください。<br>１．携帯電話番号は正しく入力されていますでしょうか？国コードの指定が必要となりますのでご注意ください。<br>　例）日本の場合：090-1234-5678 → +819012345678<br>２．SMS設定、ドメイン設定を確認してください。<br>　携帯電話番号を登録した場合はSMSにて確認コードを送信します。SMS受信が可能な状態に設定されているかを確認してください。<br>　メールアドレスを登録した場合は迷惑メールとして受信されている可能性があります。迷惑メール設定から、ku-mi-ai.comのドメイン解除をお願いします。<br>３．10分以上届かない場合は、「再送する」のリンクを押下して再度ご確認ください。"
        },{
          q: "ログアウトの方法を教えてください",
          a: "「メニュー」から「ログアウト」を選択してください。"
        },{
          q: "くみあいアプリを利用するためには必ずアプリのインストールが必要ですか",
          a: "くみあいアプリは「アプリ版」と「ブラウザ版（PC版）」をご用意しています。<br>アプリのインストールが難しい場合は、PCまたはスマートフォンのブラウザから「https://ku-mi-ai.com/」にアクセスすることでご利用可能です。<br>アプリ版でもブラウザ版でも閲覧できる情報は同じですが、アプリ版だとプッシュ通知がご利用可能です。<br>どちらも同じログイン情報でログインできます。"
        },{
          q: "「あなたのトータルスコア」とはなんですか",
          a: "くみあいアプリを利用することでカウントされるあなただけのスコアです。<br>チーム内で投稿をしたり、投稿に対してコメントをしたり、MOVIEの講座を見ることでスコアが計上されます。1日1回更新されます。"
        },{
          q: "プロフィール写真を変更したいです",
          a: "「メニュー」から「プロフィール」を選択し、『プロフィール画面』を表示します。<br>「プロフィール画像を変更」を押下し、変更したい画像を選択してください。"
        },{
          q: "「チーム」とはなんですか",
          a: "くみあいアプリの中には複数のチームが存在します。あなたは複数のチームに所属することができます。<br>チームの中では、投稿や投票を行ったり、投稿にコメントをつけたりできます。"
        },{
          q: "チームにメンバーを招待したいです",
          a: "いくつかの方法で招待が可能です。<br>《チーム参加用のQRコードを配布する（URLを配布する）》<br>　・チームTOP画面の「設定」メニューから「このチームに招待する」を選択してください。<br>　・表示されたQRコード（またはURLのコピー）を招待したいメンバーに配布してください。<br>　・【招待された側】QRコードを読み込む（またはURLにアクセスする）と招待元の『チームプロフィール画面』が表示されますので、そこから「チームに参加する」ボタンを押下してください。<br>《メールで招待する》<br>　・チームTOP画面の「設定」メニューから「チームメンバー招待/割当」を選択してください。<br>　・「メンバー外から招待する」のボタンを押下してください。<br>　・画面に表示された例示に従ってメールアドレスを入力してください。<br>　・「招待する」のボタンを押下すると、設定したアドレスに招待メールが送信されます。<br>　・【招待された側】招待メールの本文内に記載されたURLにアクセスすると招待元の『チームプロフィール画面』が表示されますので、あいことばを入力してください。<br>《QR読込》※招待対象のメンバーが既にくみあいアプリのユーザー登録済みの場合のみ利用可能です。<br>　・招待対象メンバーが「メニュー」から「MyQR表示」を選択しQRコードを表示します。<br>　・招待者が「メニュー」から「QRを読込」を選択し、招待対象者のQRコードを読み取ります。<br>　・招待対象メンバーのプロフィール画面が表示されるので「マイチームに招待する」を押下してください。<br>《ID入力》※招待したいメンバーが既にくみあいアプリのユーザー登録済みの場合のみ利用可能です。<br>　・招待対象メンバーが「メニュー」から「プロフィール」を選択し、自分のju-IDを確認します。<br>　・招待者が「メニュー」から「ID入力」を選択し、招待対象メンバーのju-IDを入力します。<br>　・「確認」を押下すると招待対象メンバーの『プロフィール画面』が表示されますので「マイチームに招待」を押下してください。"
        },{
          q: "チームに参加したいです",
          a: "いくつかの方法で参加が可能です。<br>《チームの管理者から招待を受ける》<br>　・参加したいチームの管理者から招待を受けて参加することができます。<br>　　※招待方法は「チームにメンバーを招待したいです」を参照ください。<br>《チーム参加を申請する》<br>　・「検索」から『くみあいアプリ』に登録済みのチームが検索できます（チーム作成時「検索対象とする」という設定を行った場合のみ）。<br>　・検索結果から参加したいチームを選択すると、『チームプロフィール画面』が表示されますので「チーム運営ルール」を確認してください。<br>　・運営ルールを確認の上、「このチームに参加する」を押下します。<br>　　※チームによって『自由に参加できるチーム』と『管理者からの承認が必要なチーム』があります。"
        },{
          q: "チームを検索できないようにしたいです",
          a: "以下の手順でチーム情報の変更が可能です。<br>・所属するチームのTOP画面に遷移します。<br>・画面右上の「…」（ブラウザ版の場合、「…設定」）を押下します。<br>・「チーム設定の編集」を選択します。<br>・『チーム編集画面』で「チームの公開設定」の「検索対象とする」からチェックを外し「設定完了」を押下します。<br>※チーム設定の変更はチーム管理者、共同管理者のみが可能です。"
        },{
          q: "チーム名やチーム画像などのチーム情報を変更したいです",
          a: "以下の手順でチーム情報の変更が可能です。<br>・所属するチームのTOP画面に遷移します。<br>・画面右上の「…」（ブラウザ版の場合、「…設定」）を押下します。<br>・「チーム設定の編集」を選択します。<br>・『チーム編集画面』よりチーム名やチーム画像の変更を行い「設定完了」を押下します。<br>※チーム設定の変更はチーム管理者、共同管理者のみが可能です。"
        },{
          q: "チーム内でメンバーができることを制限したいです",
          a: "以下の手順でチームメンバーができることを制限できます。<br>・所属するチームのTOP画面に遷移します。<br>・画面右上の「…」（ブラウザ版の場合、「…設定」）を押下します。<br>・「チーム設定の編集」を選択します。<br>・「チームメンバーができること」の以下のチェックをそれぞれOFFにするとチームメンバーが各機能を利用できなくなります。<br>　　▸コメント<br>　　▸新規作成（投稿）　　<br>　　▸新規作成（ミニ投票）<br>　　▸メンバー招待<br>※チーム設定の変更はチーム管理者、共同管理者のみが可能です。"
        },{
          q: "メンバーを共同管理者に設定したいです",
          a: "以下の手順でチームメンバーを共同管理者に設定できます。<br>チーム内に複数の共同管理者を設定することが可能です。<br>・所属するチームのTOP画面に遷移します。<br>・画面右上の「…」（ブラウザ版の場合、「…設定」）を押下します。<br>・「チームメンバー管理」を選択します。<br>・メンバーリストから共同管理者にしたいメンバーを選択します。<br>・共同管理者にしたいメンバーの『プロフィール画面』が表示されます。<br>・「共同管理者にする」ボタンを押下します。<br>※共同管理者の割当はチーム管理者のみ可能です。"
        },{
          q: "管理者と共同管理者の違いはなんですか？",
          a: "管理者はチーム内の全ての機能が利用可能です。<br>共同管理者はユーザー向けメニューおよび管理メニューの利用が可能ですが、以下の機能に関しては管理者による利用制限が可能です。<br>　▸メンバー招待/承認"
        },{
          q: "メンバーを管理者に設定したいです",
          a: "以下の手順でチームメンバーを管理者に設定できます。<br>チーム内に複数の管理者を設定することが可能です。<br>・所属するチームのTOP画面に遷移します。<br>・画面右上の「…」（ブラウザ版の場合、「…設定」）を押下します。<br>・「チームメンバー管理」を選択します。<br>・メンバーリストから管理者にしたいメンバーを選択します。<br>・管理者にしたいメンバーの『プロフィール画面』が表示されます。<br>・「管理者にする」ボタンを押下します。<br>※管理者の割当はチーム管理者のみ可能です。"
        },{
          q: "予約投稿をすることはできますか",
          a: "『新規投稿画面』の「公開設定」で「期間を指定」を選択します。<br>設定した「開始日時」に投稿が表示されます。"
        },{
          q: "投稿の編集をしたいです",
          a: "投稿の右上の「…」を選択し、「投稿を編集する」を押下すると『投稿編集画面』が表示されます。<br>投稿を編集し「適用する」を押下してください。"
        },{
          q: "特定のメンバーだけに投稿したいです",
          a: "『新規投稿画面』の「宛先」で「個人」を選択します。<br>プルダウンから閲覧対象のメンバーを選択し投稿することで、特定メンバー宛の投稿となります。"
        },{
          q: "特定のメンバーだけが結果を確認できるミニ投票ができますか？",
          a: "『新規投稿画面（ミニ投票）』の「投票の結果確認権限」で「個人」を選択します。<br>プルダウンから結果確認対象のメンバーを選択しミニ投票を発行することで、結果確認メンバーを特定メンバーに限定できます。"
        },{
          q: "デジタルギフトとはなんですか",
          a: "チーム内のメンバーを選んで、デジタルギフトを配布します。<br>指定したメンバーにデジタルギフト用のURLが付与された投稿を発行いたしますので、URLを押下していただくとデジタルギフトがご利用できます。<br>ご希望のチーム管理者の方はj.unionまでお問い合わせください。"
        },{
          q: "MOVIEのコースをメンバーに割り当てたいです",
          a: "いくつかの方法で割り当てが可能です。<br>《チーム内メンバーの場合》<br>　・チームTOP画面の「設定」メニューから「チームメンバー招待/割当」を選択してください。<br>　・任意の条件を設定し「検索」を押下してメンバーの一覧を表示します。<br>　・割り当てたいメンバーにチェックを入れて、「チェックボックスで選択したメンバーに対しての操作」のプルダウンから割り当てたいコースを選択してください。<br>　・「まとめてコース割当/招待」を押下すると、指定したメンバーに対して招待の投稿をします。<br>　・【招待された側】招待の投稿の本文内に記載されたURLにアクセスするとMOVIEの指定のコースが割り当てられます。<br>《チーム外メンバーの場合》<br>　・チームTOP画面の「設定」メニューから「チームメンバー招待/割当」を選択してください。<br>　・「メンバー外から招待する」のボタンを押下してください。<br>　・画面に表示された例示に従って割り当てるMOVIEのコース名とメールアドレスを入力してください。<br>　・「招待する」のボタンを押下すると、設定したアドレスに招待メールが送信されます。<br>　・【招待された側】招待メールの本文内に記載されたURLにアクセスするとチームに所属すると同時にMOVIEの指定のコースが割り当てられます。"
        },{
          q: "MOVIEのユーザー毎の視聴確認がしたいです",
          a: "以下の手順で視聴確認レポートの出力が可能です。<br>・チームTOP画面の「設定」メニューから「チームメンバー招待/割当」を選択してください。<br>・任意の条件を設定し「検索」を押下してメンバーの一覧を表示します。<br>・レポート出力したいメンバーにチェックを入れて「視聴確認レポート」を押下します。<br>・期間を設定して「ダウンロード」を押下すると指定のメンバーの視聴状況データがダウンロードできます。<br>・別途ダウンロード可能な「整形用マクロ」を利用することで「視聴確認レポート」として閲覧可能です。"
        },{
          q: "迷惑行為や公序良俗に反する投稿がありました",
          a: "以下の手順でチーム内の対象ユーザーを「強制退会」できます。<br>・所属するチームのTOP画面に遷移します。<br>・画面右上の「…」（ブラウザ版の場合、「…設定」）を押下します。<br>・「チームメンバー管理」を選択します。<br>・メンバーリストから強制退会させたいメンバーを選択します。<br>・指定したメンバーの『プロフィール画面』が表示されます。<br>・「強制退会にする」ボタンを押下します。<br>※強制退会となったメンバーは、以降、対象のチームへの参加ができません。<br>※メンバーの強制退会はチーム管理者および共同管理者のみ可能です。<br>※お困りの際にはj.unionの運営チーム（ku-mi-ai@j-union.com）までご連絡ください。"
        },{
          q: "チームから脱退したいです",
          a: "以下の手順でチームから退会できます。<br>・所属するチームのTOP画面に遷移します。<br>・画面右上の「…」（ブラウザ版の場合、「…設定」）を押下します。<br>・「このチームを脱退する」を押下します。<br>※チームから脱退すると、チームのプロフィール画面しか閲覧できなくなります。チーム内で今まで発信した内容はそのまま残ります。"
        },{
          q: "くみあいアプリからアカウントを削除（退会）したいです",
          a: "くみあいアプリの退会は"+"こちら".link("/open/delete_account")+"です。<br>アカウントを削除した場合、くみあいアプリへのログインはできなくなります。また、他サービスで「くみあいアプリ共通ログイン」を利用していた場合も利用できなくなります。"
        }]
      }
      // , {
      //   h: "サービス関連",
      //   qas: [{
      //     q: "チームは誰でも作れますか？",
      //     a: "ここに回答を記述します。このテキストはダミーです。ここに回答を記述します。このテキストはダミーです。ここに回答を記述します。このテキストはダミーです。"
      //   }]
      // }
      ],
      auth_info: this.$cookies.get('auth_info'),
    }
  }

}
</script>
<style lang="scss" module>
.wrapper {
  color: $keyBlack;
  background-color: $openBg;
  text-align: left;
  margin: 0 auto;
  box-sizing: border-box;
  width: 1080px;
  padding: 68px 210px;

  @include mobile() {
    width: 375px;
    padding: 42px 32px;
  }

  * {
    margin: 0;
  }

  .h1 {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 63px;

    @include mobile() {
      font-size: 24px;
      margin-bottom: 55px;
    }
  }
  .section {
    &:not(:last-child) {
      margin-bottom: 26px;

      @include mobile() {
        margin-bottom: 22px;
      }
    }

    .h2 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;

      @include mobile() {
        font-size: 16px;
        margin-bottom: 16px;
      }
    }
  }
}
.accordion {
  &:not(:last-child) {
    margin-bottom: 26px;

    @include mobile() {
      margin-bottom: 22px;
    }
  }

  .p {
    font-size: 13px;
    line-height: 26px;
    padding: 20px 24px 0 44px;

    @include mobile() {
      font-size: 11px;
      line-height: 16px;
    }
  }
}
</style>
